import {Injectable} from '@angular/core';
import {DomSanitizer} from '@angular/platform-browser';
import {MatIconRegistry} from '@angular/material/icon';

@Injectable({
  providedIn: 'root'
})
export class CustomIconService {
  private iconPath = 'assets/icons';

  constructor(
    private iconRegistry: MatIconRegistry,
    private sanitizer: DomSanitizer
  ) {
  }

  registerIcons(): void {
    const icons: string[] = [
      'generate_document',
      'view_document',
      'download_document',
      'upload_document',
      'person',
      'person-UBO',
      'apartment',
      'share',
      'bin',
      'folder_managed',
      // client visibility/edit icons
      'client_enabled',
      'client_disabled',
      'reject_icon',
      'approved_icon',
      'check_circle_outline',
      'processing_document'
    ];

    icons.forEach(iconName => {
      this.iconRegistry.addSvgIcon(
        iconName,
        this.sanitizer.bypassSecurityTrustResourceUrl(`${this.iconPath}/${iconName}.svg`)
      );
    });
  }
}
